import {
    DTOCardFormField, FieldInCard,
} from 'app/types/form.types'

import {
    ChangeRequestApprovalType,
    Order,
} from 'app/Apps/OrderManagement/Orders/orders.types'

const getFields = (
    order: Order, isDeliveryRoad: boolean,
): DTOCardFormField<keyof (Order & ChangeRequestApprovalType
)>[] => {
    return [{
        id: 'requiredContainers',
        className: 'requiredContainers',
        title: 'Required Containers',
        fields: [
            {
                id: 'column_requiredContainers_1',
                fields: [
                    {
                        name: 'requiredContainers',
                        componentName: 'RequiredContainerByProductTypeList',
                        allowedProductTypes: order?.allowedProductTypes,
                        disabled: true,
                        labelKey: 'OrderByNumberView.requiredContainers',
                    },
                    {
                        name: 'allowedProductTypes',
                        componentName: 'AllowedContainerTypes',
                        disabled: true,
                        noLabel: true,
                    },
                ],
            },
            {
                id: 'column_requiredContainers_2',
                fields: [
                    {
                        name: 'currentRequestedHandover',
                        componentName: 'DateTimeZonedSelect',
                        disabled: true,
                        labelKey: 'ChangeRequestApproval.currentRequestedHandover',
                    },
                    {
                        name: 'pendingRequestedHandover',
                        componentName: 'DateTimeZonedSelect',
                        disabled: true,
                        labelKey: 'ChangeRequestApproval.pendingRequestedHandover',
                    },
                ],
            },
            ...isDeliveryRoad ? [{
                id: 'column_requiredContainers_3',
                fields: [
                    {
                        name: 'estimatedPickup',
                        componentName: 'DateTimeZonedSelect',
                        labelKey: 'CustomerTransportCreateDto.estimatedPickup',
                    },
                    {
                        name: 'requestedPickup',
                        componentName: 'DateTimeZonedSelect',
                        labelKey: 'OrderStep.requestedPickup',
                    },
                ],
            }] as FieldInCard<keyof (Order & ChangeRequestApprovalType)>[] : [],
        ],
    }]
}

export default getFields
